/**
 * Renders a color palette with the given color combinations.
 * See ColorPalette.defaultProps for further explanation.
 */
import React, { Component } from 'react';

import './ConfiguratorPalette.css?v=2';
import {__} from "../Translator";
import isNotIronGray from '../utils/isNotIronGray';
import Dropdown from './Dropdown';

function makeColorSvg(material) {
  return (
    <svg style={{ width: 20, height: 16 }} viewBox="0 0 344 267" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g stroke="none" fill="none" fillRule="evenodd">
          <polygon fill={material.rgb_brighter} points="0 0 268.442993 0 343.5 266.655803 71.6321587 266.655803"/>
          <path fill={material.rgb} d="M339.650026,252.978037 C185.512253,251.218643 56.7252024,143.943255 22.1369994,9.34363698e-13 L268.442993,0 L339.650048,252.978038 L339.650026,252.978037 Z"/>
      </g>
    </svg>
  );
}

function filterOldColors(key){
    return  key !== 'iron_grey' && key !== 'stone_grey';
}

function filterFabricAndReflex(key){
  return  key !== 'fabric' && key !== 'reflex';
}

class ColorPalette extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: props.selected,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selected: nextProps.selected
    });
  }

  render() {
    const materialKeys = Object.keys(this.props.materials).filter(isNotIronGray);
    const normalColorKeys = Object.entries(this.props.materials).filter((color) => color[1].type === "STANDARD").map( material => material[0] );
    const specialColorKeys = Object.entries(this.props.materials).filter((color) => color[1].type === "SPECIAL").map( material => material[0] );
    const fluoColorKeys = Object.entries(this.props.materials).filter((color) => color[1].type === "FLUORESCENT").map( material => material[0] );

    return this.props.small ? (
      <div className="configuratorPalette m--small">
        <Dropdown
          selected={this.state.selected}
          options={materialKeys.filter(filterOldColors).filter(filterFabricAndReflex).map(materialKey => ({
            value: this.props.materials[materialKey].code,
            text: this.props.materials[materialKey].label,
            rightIcon: makeColorSvg(this.props.materials[materialKey]),
          }))}
          onChange={code => this.props.onClick(code)}
        />
      </div>
    ) : (
      <div>
        <div className="configuratorPalette">
          <p>{__('Standard colors')}</p>
          {normalColorKeys.filter(filterOldColors).map(materialKey => {
            return (
              <div key={materialKey} className="material-hover" data-leather={__(materialKey)}>
                <button
                  onClick={() => this.props.onClick(materialKey)}
                  className={`m--leather ${this.state.selected === materialKey ? 'is-selected' : ''}`}
                  style={{ backgroundColor: this.props.materials[materialKey].rgb_brighter }}
                >
                  <span style={{ backgroundColor: this.props.materials[materialKey].rgb }} />
                </button>
              </div>
            )
          })}
        </div>
        {specialColorKeys.length > 0 && (
        <div className="configuratorPalette">
          <p>{__('Special colors')}</p>
          {specialColorKeys.filter(filterOldColors).map(materialKey => {
            return (
              <div key={materialKey} className="material-hover" data-leather={__(materialKey)}>
                <button
                  onClick={() => this.props.onClick(materialKey)}
                  className={`m--leather ${this.state.selected === materialKey ? 'is-selected' : ''}`}
                  style={{ backgroundColor: this.props.materials[materialKey].rgb_brighter }}
                >
                  <span style={{ backgroundColor: this.props.materials[materialKey].rgb }} />
                </button>
              </div>
            )
          })}
        </div>
        )}
        {fluoColorKeys.length > 0 && (
        <div className="configuratorPalette">
          <p>{__('Fluorescent colors')}</p>
          <div className="flourescentColorWarning">
            {__('Fluorescent colors warning')}
          </div>
          {fluoColorKeys.filter(filterOldColors).map(materialKey => {
            return (
              <div key={materialKey} className="material-hover" data-leather={__(materialKey)}>
                <button
                  onClick={() => this.props.onClick(materialKey)}
                  className={`m--leather ${this.state.selected === materialKey ? 'is-selected' : ''}`}
                  style={{ backgroundColor: this.props.materials[materialKey].rgb_brighter }}
                >
                  <span style={{ backgroundColor: this.props.materials[materialKey].rgb }} />
                </button>
              </div>
            )
          })}
        </div>
        )}
      </div>
    );
  }
}

/**
 * @type {{materials: {}, combinations: {}, selected: {}, onClick: (function())}}
 *
 * - materials is an object mapping a colorKey or material to its RGB counterpart.
 * - combinations is an object mapping every combinationKey to an array of
 *   materials, used to render a representation of the combination.
 * - selected is an object representing the current selected patch/part.
 * - onClick is the callback invoked when a combination is clicked. Use this
 *   callback to update the Product.
 */
ColorPalette.defaultProps = {
  materials: {},
  combinations: {},
  selected: {},
  onClick: () => {},
};

export default ColorPalette;



// WEBPACK FOOTER //
// ./src/components/ColorPalette.js